import React from 'react';

const MessageSpinner = () => (
  <div className='loading-spinner-container'>
    <div className='loading-spinner' />
  </div>
);

export default MessageSpinner;
